import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LabelConstants } from '../../../constants/label-constants';
import { AssignmentGroupSharedDataService } from '../../../services/assignment-group-shared-data.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  @Output() confirmed = new EventEmitter<any>();
  @Output() dialogClosed = new EventEmitter<boolean>();
  @Input() InactiveAssignmentGroupField: string | string[] = [];
  @Input() messageForApprovedAndEffcetivePhases : string = '';

  confirmationMessage: string = LabelConstants.InActiveGroupMessage;
  isModalVisable = true;
  fieldNames = '';

  constructor(private assignmentGroupSharedDataService:AssignmentGroupSharedDataService
    ) {}

  ngOnInit(): void {
    if (this.messageForApprovedAndEffcetivePhases) {
      this.confirmationMessage = this.messageForApprovedAndEffcetivePhases;
    } else if (Array.isArray(this.InactiveAssignmentGroupField)) {
      this.fieldNames = this.assignmentGroupSharedDataService.getDistinctSources(this.InactiveAssignmentGroupField);
      this.confirmationMessage = this.confirmationMessage.replace("field", this.fieldNames);
    } else {
      this.fieldNames = this.InactiveAssignmentGroupField;
      this.confirmationMessage = this.confirmationMessage.replace("field", this.fieldNames);
    }
  }
  

  saveDocumentData() {
    this.confirmed.emit();
  }

  closeAssignmentGroupValidationDailog() {
    this.dialogClosed.emit(false);
  }

  onDialogHide() {
    this.dialogClosed.emit(false);
  }
}
